import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-save-modal-popup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './save-modal-popup.component.html',
  styleUrl: './save-modal-popup.component.scss'
})
export class SaveModalPopupComponent {
  isVisible = false;
  comments: string = '';
  actionType: string = '';

  @Output() confirmAction = new EventEmitter<{ action: string, comments: string }>();

  open(action: string) {
    this.actionType = action;
    this.isVisible = true;
    this.comments = '';
  }

  confirm() {
    this.confirmAction.emit({ action: this.actionType, comments: this.comments });
    this.isVisible = false;
  }

  cancel() {
    this.isVisible = false;
  }
}
